export default __webpack_public_path__ + "static/Revontulikamera_loop_TAUSTA_BLUR_PAKATTU-bcc1b57335094ea5d1793e432f01c309.mp4";